import { render } from "./CustomizedFee.vue?vue&type=template&id=f3001108&scoped=true"
import script from "./CustomizedFee.vue?vue&type=script&lang=js"
export * from "./CustomizedFee.vue?vue&type=script&lang=js"

import "./CustomizedFee.vue?vue&type=style&index=0&id=f3001108&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3001108"]])

export default __exports__